import GenericService from 'services/genericService';
import { Observable } from 'rxjs';

import {
	deleteAllAccountsForArborIdOperation,
	deleteAllAccountsForArborIdInitialize,
} from 'utils/api/queries/omantelApi';

export class BillingAccountsService extends GenericService {
	public static deleteAllAccountsForArborIdInitialize(accountId: string, orgAccountId: string): Observable<any> {
		return deleteAllAccountsForArborIdInitialize(accountId, orgAccountId)
			.disableCache()
			.withErrorHandling()
			.call();
	}

	public static deleteAllAccountsForArborIdOperation(
		accountId: string,
		orgAccountId: string,
		token: string,
		documentId?: string
	): Observable<any> {
		return deleteAllAccountsForArborIdOperation(accountId, orgAccountId, token, documentId)
			.disableCache()
			.withErrorHandling()
			.call();
	}
}
